import { analyticsOnClick } from 'analytics';
import { navigate } from 'gatsby';

const ALLOWED_DOMAINS = [ 'preview.standardchartered.com', 'preview.sc.bank.in', 'sc.com', 'sc.bank.in' ];
const DEFAULT_PATH = '/';

let previous_path = '';

/**
 * Purpose of this function is to get path from gatsby-browser and set in local variable here.
 *
 * @param {string} path - path for redirection.
 * @returns {void}
 */
export const setPreviousPath = ( path ) => {
	previous_path = path;
};

/**
 * Purpose of this function is to check and response where to redirect user on click of back button.
 *
 * @returns {string} - A url for redirection.
 */
export const getRedirectLink = () => {
	// Case 1: Direct visit to URL, in this case there would be no previous URL.
	if ( ! previous_path ) {
		return DEFAULT_PATH;
	}

	// Case 2: If the previous URL is not a SC defined internal platform URL.
	if ( ! ALLOWED_DOMAINS.some( ( domain ) => previous_path.includes( domain ) ) ) {
		return DEFAULT_PATH;
	}

	// Case 3: If previous URL is a SC defined internal platform URL.
	return 'TRIGGER_HISTORY_BACK';
};

/**
 * Purpose of this function is to navigate user to appropriate URL.
 *
 * @param {Event} dom_event - DOM event triggered by the button click.
 * @param {string} redirection_link - Link where user should be redirected.
 * @param {string} text - For analytics tracking purpose (event type identification).
 * @param {string} location - For analytics tracking purpose (event URL identification).
 * @returns {void}
 */
export const redirectUser = ( dom_event, redirection_link, text, location ) => {
	analyticsOnClick(
		dom_event,
		'text',
		text || 'back',
		location || ''
	);

	if ( redirection_link === 'TRIGGER_HISTORY_BACK' ) {
		window?.history?.back();
	} else {
		navigate( redirection_link );
	}
};
